/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const roleEnumSchema = z.enum([
  'dipendente',
  'cliente',
  'amministratore',
  'utenteEvoluto',
  'consulente',
]);
